export default {"src":"/_next/static/media/view-estimate.6e45b426.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};